import { reportError } from "lib/withSentry"

export default async function fetchWithTimeout(resource, options = {}) {
  const { timeout = 3000, headers = {}, params = {}, ...restOptions } = options

  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), timeout)

  try {
    const queryString = new URLSearchParams(params).toString()
    const fullUrl = queryString ? `${resource}?${queryString}` : resource

    const response = await fetch(fullUrl, {
      ...restOptions,
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "162C7D559DE4DD383DFD9867A456D8AA",
        ...headers
      },
      signal: controller.signal
    })
    return response
  } catch (error) {
    if (error?.name !== "AbortError") {
      reportError(error, "fetchWithTimeout")
    }
  } finally {
    clearTimeout(timeoutId)
  }
}
